import {
	type AstNodeDescription,
	AstUtils,
	Cancellation,
	DefaultScopeComputation,
	type LangiumDocument,
} from "langium";
import { interruptAndCheck } from "langium";
import type { CancellationToken } from "vscode-languageserver";

import { isAlias, isDirective, isEndpoint, isEnum, isModule, isScalar, isStruct } from "../generated/ast.js";

export class IprotoScopeComputation extends DefaultScopeComputation {
	override async computeExports(
		document: LangiumDocument,
		cancelToken?: CancellationToken,
	): Promise<AstNodeDescription[]> {
		const descriptions: AstNodeDescription[] = [];

		for (const node of AstUtils.streamAllContents(document.parseResult.value)) {
			await interruptAndCheck(cancelToken || Cancellation.CancellationToken.None);

			if (
				isEnum(node) ||
				isStruct(node) ||
				isEndpoint(node) ||
				isScalar(node) ||
				isDirective(node) ||
				isModule(node) ||
				isAlias(node)
			) {
				const name = this.nameProvider.getName(node);

				if (name) {
					descriptions.push(this.descriptions.createDescription(node, name, document));
				}
			}
		}

		return descriptions;
	}
}
